import React from 'react'

const WeddingText = () => {
  return (
    <div className='mb-5 text-sm lg:mb-10 lg:text-2xl font-bree'>Pernikahan</div>
  )
}

export default WeddingText